// extracted by mini-css-extract-plugin
export default {"RoundB":"style_RoundB__kHf20","RoundedButton":"style_RoundedButton__e2Uev","RoundedButtonPlay":"style_RoundedButtonPlay__foWnZ"};